import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PrefillLmjInfoFromSessionBannerStatus } from 'src/app/pages/flex/enums/prefill-lmj-info-from-session-banner-status.enum';
import { UtilityService } from 'src/app/shared/services/utility.service';

@Component({
  selector: 'app-prefill-lmj-info-from-session-banner',
  templateUrl: './prefill-lmj-info-from-session-banner.component.html',
  styleUrls: ['./prefill-lmj-info-from-session-banner.component.scss'],
})
export class PrefillLmjInfoFromSessionBannerComponent {
  // Alias to expose to the template.
  readonly PrefillLmjInfoFromSessionBannerStatus = PrefillLmjInfoFromSessionBannerStatus;

  // The banner status to display. This is based on the successful result of prefilling the last minute job form.
  @Input() bannerStatus = PrefillLmjInfoFromSessionBannerStatus.PREFILL;

  // Event emitter for retrying to prefill the LMJ from scheduled event info.
  @Output() retryPrefill = new EventEmitter();

  // Event emitter for dismissing the banner.
  @Output() dismissBanner = new EventEmitter();

  constructor(private utilityService: UtilityService) {}

  /**
   * Opens the link to the in app browser.
   *
   * @param link - The url link to open.
   */
  openExternalLink(link: string): void {
    this.utilityService.openExternalLink(link);
  }
}
